import React, { useRef,useState } from "react";
import { Table} from "antd";
import SearchBox from "./components/searchBox";
import useTable from "@/hooks/table";
import { getJurisdiction } from "@/statics/js/jurisdiction";
import { _gpsInfoList,_getBikeStatus } from "@/statics/js/api.js";
import moment from "moment";

const Index = () => {
  const columns = [
    {
      title: "GPS编号",
      dataIndex: "codeId",
    },
    {
      title: "代理商",
      dataIndex: "agentName",
    },
    {
      title: "站点",
      dataIndex: "siteName",
    },
    {
      title: "是否在线",
      dataIndex: "",
      width: 120,
      render: (text) => (
        <span>
          {text.gps
            ? (text.lock ? "锁定，" : "未锁，") +
              (text.online ? "在线" : "离线")
            : ""}
          <br />
          <span>{text.speed || text.time}</span>
        </span>
      ),
    },
    {
      title: "是否到期",
      dataIndex: "expire",
    },
    {
      title: "车辆信息",
      dataIndex: "",
      render: (text) =>
        text && (
          <span>
            {text.checkBikeId && "车架号：" + text.checkBikeId}
            {text.checkBikeId && <br />}
            {text.checkCCodeId && "GPS号：" + text.checkCCodeId}
            {text.checkCCodeId && <br />}
            {text.imei && "二维码：" + text.imei}
            {text.imei && <br />}
            {text.vin && "车牌号：" + text.vin}
          </span>
        ),
    },
    {
      title: "到期时间",
      width: 120,
      dataIndex: "expirationTime",
    }
  ];
  const modalRef = useRef();
  const [list,setList]= useState([]);
  const {
    pageSize,
    curPage,
    totalCount,
    loading,
    handleSearch,
    handlePageChange,
    handleRefresh,
  } = useTable({
    action: _gpsInfoList,
    pageSizeKey: "rows",
    curPageKey: "page",
    done: async (rows) => {
      const action=[]
      for(let i = 0; i < rows.length; i++){
        const {bikeId} = rows[i]
        action.push(getListStatus(bikeId))
      }
      const arr = await Promise.all(action)
      const newList = rows.map((item,index) => {
        const row = arr[index]
        if(row){
          item.gpsType = row.gpsType;
          item.gps = row.gps;
          item.lock = row.lock;
          item.online = row.online;
          item.speed = row.speed;
          item.time = row.time;
        }
        return item
      });
      setList(newList)
    }
  });
  const getListStatus = async (id) => {
    if(!id) return;
    const res = await _getBikeStatus({ids: [id]})
    const {code,data=[]} = res.data || {}
    if (code != 200) return;
    const [row={}] = data || []
    return row
  }
  const search = (values) => {
    let [startExpirationTime, endExpirationTime] = values.expirationTime || [];
    values.startExpirationTime = startExpirationTime
      ? moment(startExpirationTime).format("YYYY-MM-DD") + " 00:00:00"
      : undefined;
    values.endExpirationTime = endExpirationTime
      ? moment(endExpirationTime).format("YYYY-MM-DD") + " 23:59:59"
      : undefined;
    delete values.expirationTime;
    const params = {
      ...values,
    };
    handleSearch(params);
  };
  return !getJurisdiction(1127) ? (
    "暂无操作权限！"
  ) : (
    <div>
      <div className="select-form">
        <SearchBox search={search} />
      </div>
      <Table
        rowKey="id"
        bordered
        columns={columns}
        dataSource={list}
        loading={loading}
        pagination={{
          showQuickJumper: true,
          defaultPageSize: pageSize,
          showSizeChanger: true,
          onShowSizeChange: handlePageChange,
          onChange: handlePageChange,
          total: totalCount,
          current: curPage,
          showTotal: (totalCount) => `总共 ${totalCount} 条记录`,
        }}
      />
    </div>
  );
};

export default Index;
